import { gql } from '@apollo/client';
import { SubscriptionInfoShared } from '../fragments';

export default gql`
  query subscriptions(
    $accountId: ID
    $consecutiveFailuresMax: Int
    $consecutiveFailuresMin: Int
    $createdAtStart: String
    $createdAtEnd: String
    $endedAtStart: String
    $endedAtEnd: String
    $name: [String!]
    $needsCreditCard: Boolean
    $needsUpdatedCard: Boolean
    $partnerLocationId: [ID!]
    $partnerOrganizationId: [ID!]
    $patientId: ID
    $pausedAt: Boolean
    $renewalAtStart: String
    $renewalAtEnd: String
    $startedAtStart: String
    $startedAtEnd: String
    $state: [String!]
    $limit: Int
    $offset: Int
  ) {
    subscriptions(
      accountId: $accountId
      consecutiveFailuresMax: $consecutiveFailuresMax
      consecutiveFailuresMin: $consecutiveFailuresMin
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      endedAtStart: $endedAtStart
      endedAtEnd: $endedAtEnd
      name: $name
      needsCreditCard: $needsCreditCard
      needsUpdatedCard: $needsUpdatedCard
      partnerLocationId: $partnerLocationId
      partnerOrganizationId: $partnerOrganizationId
      patientId: $patientId
      pausedAt: $pausedAt
      renewalAtStart: $renewalAtStart
      renewalAtEnd: $renewalAtEnd
      startedAtStart: $startedAtStart
      startedAtEnd: $startedAtEnd
      state: $state
      limit: $limit
      offset: $offset
    ) {
      ...SubscriptionInfoShared
    }
  }
  ${SubscriptionInfoShared}
`;
